import { Data } from "../../types/Data";
import { State } from "../../types/State";

export function getLabelLocalite({
  state,
  data,
  defaultLabel,
}: {
  state: State;
  data: Data;
  defaultLabel: string;
}) {
  if (!state["code-postal"] || !state["ville"]) return defaultLabel;
  return `${state["ville"]} (${state["code-postal"]}) ${
    state["localite-range"] ? ` +${state["localite-range"]} km` : ""
  }`;
}
